import React, {Component, createRef} from 'react';

// CSS
import './Exams.scss';

// Helper
import {setCookie, checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { EmptyState, TableWait, Chip, UserCell, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

// Properties
const properties = require('../../properties.json');

class AllInbox extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        globalFilter: null,

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,
        teacherId: null ,
        // Data
        data: [],

        material:null,
        selectedType:null,
        // Update Data
        resend: false,

        // every material the teacher has, each with its stage name on it --
        // the options for the material filter
        allMaterials: [],


        // the rows are on their way
        tableLoading: true,
        loadingMaterials: true,
    }

    // NOTE: the legacy call also filtered by schoolId (schoolStagesId), but
    // GET /api/manasa/messages only accepts materialId and readDone -- there
    // is no school-stage filter on the messages endpoint. The school-stage
    // dropdown that used to sit here only existed to narrow the materials
    // list; the flat materials lookup carries each material's stage name, so
    // it is gone and the material filter stands on its own.
    getInbox = (materialId, selectedType) => {
        var _this = this;
        this.setState({ tableLoading: true });
        // Get Messages From API
        apiFetch("/messages", { query: { materialId, readDone: selectedType } })
        .then(fetchExams => {
            this.setState({
                data: fetchExams,
                tableLoading: false,
            });
        })
        .catch(error => {
            console.error('Error:', error)
            this.setState({ tableLoading: false });

            _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
        });
    }

    // The full material list, for the filter menu options -- a filter has to
    // offer every material, not just the ones on the rows in view. Each row
    // now carries its own materialName, so nothing else needs this.
    getMaterials = () => {
        const user = getCurrentUser();
        apiFetch("/lookup/materials", { query: { branchId: user?.branchId, teacherUserId: user?.userId } })
        .then(materials => {
            this.setState({ allMaterials: materials, loadingMaterials: false });
        })
        .catch(error => {
            console.error('Error:', error);
            this.setState({ loadingMaterials: false });
        });
    }


    componentDidMount () {
        document.title = properties.site_name + " | كل الاسئله الوارده";
        // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        }

        this.getInbox(this.state.material, this.state.selectedType);
        this.getMaterials();
    }

    render() {
        const { tableLoading, data } = this.state;

        const type = [
            { label: "تم الرد", value: 1 },
            { label: "لم يتم الرد", value: 0 },
        ];

        // each option names its own stage, so the same material under two
        // stages is still told apart
        const materials = this.state.allMaterials.map(m => ({
            label: m.stageName ? `${m.name} — ${m.stageName}` : m.name,
            value: m.id,
        }));

        // the two menus that narrow the table sit on the toolbar itself
        const filters = (
            <>
                <span className="ui-filter is-inline">
                    <Dropdown
                        value={this.state.material}
                        options={materials}
                        placeholder="كل المواد"
                        onChange={(e) =>
                            this.setState({ material: e.value },
                                () => this.getInbox(e.value, this.state.selectedType))
                        }
                        name="subject"
                        showClear
                        emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                    />
                </span>

                <span className="ui-filter is-inline">
                    <Dropdown
                        value={this.state.selectedType}
                        options={type}
                        placeholder="الكل"
                        onChange={(e) =>
                            this.setState({ selectedType: e.value },
                                () => this.getInbox(this.state.material, e.value))
                        }
                        optionLabel="label"
                        showClear
                    />
                </span>
            </>
        );

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="فتح الرسالة">
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-secondary" onClick={() => window.location.href = `/allInbox/edit/${rowData.id}`} />
                    </Tip>
                </React.Fragment>
            );
        }

        // the message as it reads: its subject, with the start of the question
        // under it rather than the whole body stretching the row
        const messageBody = (row) => (
            <span className="ui-stack">
                <b>{row.subject || "من غير عنوان"}</b>
                <small>{row.body || "—"}</small>
            </span>
        );

        // the list carries the name and mobile of whoever sent it now, so
        // the page no longer downloads every student in the branch to
        // label a row
        const studentBody = (row) => {
            if (!row.studentName) return <span className="ui-bits is-none">طالب #{row.studentProfileId}</span>;
            return <UserCell name={row.studentName} sub={row.studentMobile} />;
        };

        // what the message carries besides its text
        const contentBody = (row) => {
            const bits = [
                row.image ? { icon: "pi pi-image", title: "صورة" } : null,
                row.audio ? { icon: "pi pi-volume-up", title: "صوت" } : null,
                row.video ? { icon: "pi pi-video", title: "فيديو" } : null,
            ].filter(Boolean);

            if (!bits.length) return <span className="ui-bits is-none">نص بس</span>;

            return (
                <span className="ui-bits">
                    {bits.map((b) => (
                        <span className="bit" key={b.icon} title={b.title}>
                            <i className={b.icon}></i>
                        </span>
                    ))}
                </span>
            );
        };

        // "تم الرد" is a state, so it is read as one
        const statusBody = (row) => (
            row.readDone
                ? <Chip kind="ok">تم الرد</Chip>
                : <Chip kind="wait">لم يتم الرد</Chip>
        );

        const dateBody = (row) => {
            if (!row.sentDate) return "—";
            const d = new Date(row.sentDate);
            if (isNaN(d.getTime())) return row.sentDate;
            return (
                <span className="ui-stack">
                    <b>{d.toLocaleDateString('ar-EG', { day: 'numeric', month: 'short', year: 'numeric' })}</b>
                    <small>{d.toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit' })}</small>
                </span>
            );
        };

        // how many are still waiting on a reply, counted from the rows on the
        // table rather than asked for separately
        const waiting = data.filter((r) => !r.readDone).length;

        return (
            <>
                <Header pageName="كل الاسئله الوارده" />

                <Toast ref={this.toast}></Toast>

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في الاسئله"
                                    count={
                                        tableLoading
                                            ? null
                                            : waiting
                                            ? `${data.length} سؤال · ${waiting} مستني رد`
                                            : `${data.length} سؤال`
                                    }
                                    filters={filters}
                                />

                                <DataTable
                                    sortable
                                    globalFilter={this.state.globalFilter}
                                    className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                    value={data}
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[10,20,50]}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                    emptyMessage={
                                        tableLoading ? (
                                            <TableWait />
                                        ) : (
                                            <EmptyState
                                                title="لا يوجد اسئله"
                                                hint="لما طلابك يبعتوا أسئلة هتلاقيها هنا"
                                                icon="pi pi-inbox"
                                            />
                                        )
                                    }
                                >
                                    {/* No per-column filter boxes: the search in
                                        the toolbar already looks across the table. */}
                                    <Column sortable field="subject" body={messageBody} header="الرسالة"></Column>
                                    <Column sortable field="studentName" body={studentBody} header="الطالب"></Column>
                                    <Column
                                        sortable
                                        field="materialName"
                                        body={(row) => row.materialName || "—"}
                                        header="الماده"
                                    ></Column>
                                    <Column body={contentBody} header="المرفقات"></Column>
                                    <Column sortable field="sentDate" body={dateBody} header="تاريخ الارسال"></Column>
                                    <Column sortable field="readDone" body={statusBody} header="الحالة"></Column>
                                    <Column header="رؤيه" body={actionBodyTemplate}></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AllInbox;
